import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Lottie from 'react-lottie';
import * as animationData from '../../../img/lottie/240187_ARG_Website_Arrow.json'

// @ts-ignore
import {ReactComponent as Arrow} from "../../../img/Argenco_pijl_eco_rgb.svg";
// @ts-ignore
import {ReactComponent as ArrowDark} from "../../../img/Argenco_pijl_green_rgb.svg";
// @ts-ignore
import ImgLevi from "../../../img/cut/ArgenCo_Levi_CEO.jpg";
// @ts-ignore
import {ReactComponent as Plus} from "../../../img/ArgenCo_icon_plus_rgb.svg";
// @ts-ignore
import {ReactComponent as Graph} from "../../../img/ArgenCo_icon_graph_rgb.svg";
// @ts-ignore
import {ReactComponent as House} from "../../../img/ArgenCo_icon_house_rgb.svg";
// @ts-ignore
import {ReactComponent as Clover} from "../../../img/ArgenCo_icon_clover_rgb.svg";

import {
  Box
} from '@mui/material';

// import {
//   Cta,
//   Footer,
//   Section
// } from '../custom';
import {
  Dt,
  MutedGreenButton,
  ShareShower,
  Typography
} from '../styled';

import { StockTransfer as ST } from '../../../models/StockTransfer';


type Props = {
  transfer?: ST;
  isBlank?: boolean;
  isNew?: boolean;
  isApproved?: boolean;
  onClick: () => void;
  shareTypeTag: 'A' | 'B';
  stateColour?: string;
  sx?: any;
};

export const StockTransferTile: FunctionComponent<Props> = ({transfer, stateColour, isNew, isBlank, isApproved, sx, onClick, shareTypeTag}) => {
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);
  const navigate = useNavigate();

  const [stopped, setStopped] = useState(true);

  return (<>
    <Box
      sx={{
        position: 'relative',
        zIndex: 1200,
        cursor: 'pointer',
        ...sx
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        onClick();
      }}
      onMouseEnter={() => { setStopped(false) }} 
      onMouseLeave={() => { setStopped(true) }}
    >
      <Lottie
        options={{
          loop: false,
          autoplay: false, 
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
        style={{
          position: 'absolute',
          right: 32,
          bottom: 32,
          zIndex: 1205
        }}
        height={34}
        width={34}
        isClickToPauseDisabled
        isStopped={stopped}
      />

      <Box sx={{
        borderRadius: '10px',
        border: '2px solid transparent',
        ...(!!stateColour ? {
          borderColor: stateColour
        } : {}),
        overflow: 'hidden',
        width: '100%',
        padding: 4,
        height: '370px',
        // background: `no-repeat url(${ImgLevi})`,
        // backgroundSize: 'cover',
        backgroundColor: 'white'
      }}>
        {!!isBlank && <Plus style={{height: '48px'}} />}
        {!!isNew && <Plus style={{height: '48px'}} />}
        {!isNew && !isBlank && <Graph style={{height: '48px'}} />}
        {/* {!!isApproved && <House style={{height: '48px'}} />} */}
        {!!isApproved && <Clover style={{height: '48px'}} />}
        {!!isNew && <Typography variant="h3" sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'initial',
          display: '-webkit-box',
          '-webkit-line-clamp': '3',
          '-webkit-box-orient': 'vertical',
          textTransform: 'none',
          marginTop: 1
        }}>{t("nw.emission.transfers.add_order")}</Typography>}
        {!!isBlank && <Typography variant="h3" sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'initial',
          display: '-webkit-box',
          '-webkit-line-clamp': '3',
          '-webkit-box-orient': 'vertical',
          textTransform: 'none',
          marginTop: 1
        }}>{t("nw.transfers.download_blank")}</Typography>}

        {!isNew && !!transfer && <>
          <Typography variant="h5" sx={{
            marginTop: 1
          }}>{t("nw.emission.stocks.card.receiver")}</Typography>
          <Typography variant="body1" sx={{
            marginTop: 0,
            paddingLeft: 2
          }}>{transfer.receiver_name}</Typography>

          <Typography variant="h5" sx={{
            marginTop: 1
          }}>{t("nw.transfers.card.order_time")}</Typography>
          <Typography variant="body1" sx={{
            marginTop: 0,
            paddingLeft: 2
          }}><Dt d={transfer.created_at} f="d LLLL y - t"/></Typography>

          <Typography variant="h5" sx={{
            marginTop: 1
          }}>{t("nw.emission.stocks.card.amount")}</Typography>
          <ShareShower variant="body1" amount={transfer.stock_number || 0} share={shareTypeTag} sx={{
            marginTop: 0,
            paddingLeft: 2
          }} />

          <Typography variant="h5" sx={{
            marginTop: 1
          }}>{t("nw.transfers.card.status")}</Typography>
          <Typography variant="body1" sx={{
            marginTop: 0,
            paddingLeft: 2,
            ...(!!stateColour ? {
              color: stateColour
            } : {}),
          }}>{t(`nw.transfer.statuses.${transfer.status}`)}</Typography>

          {/* <Typography variant="body2" sx={{
            marginTop: 1,
            paddingLeft: 2
          }}>{transfer.status_updated}</Typography> */}
        </>}

        <MutedGreenButton
          id="goto"
          label={!!isBlank ? t("nw.emission.transfers.card.download_blank") : !!isNew ? t("nw.emission.transfers.card.new_order") : t("nw.emission.transfers.card.view_order")}
          onClick={() => {
            onClick();
          }}
          sx={{
            position: 'absolute',
            bottom: 32,
            left: 32
          }}
        />
      </Box>
    </Box>
  </>);
}